window.PlummeI18n.register('no', {
  "clo.cash.quickComments": "Hurtigkommentarer",
  "clo.cash.quickCountLabel": "Opptalt av daglig leder",
  "clo.cash.quickCountText": "Kontantbeholdningen er fysisk opptalt per 31.12.{{year}} av daglig leder.",
  "clo.cash.quickSheetLabel": "Opptellingsskjema lagret",
  "clo.cash.quickSheetText": "Signert opptellingsskjema er kontrollert og lagret i bilagsmappen.",
  "clo.cash.quickReportLabel": "Kontrollert mot kasserapport",
  "clo.cash.quickReportText": "Opptellingen er kontrollert mot kasserapporten per 31.12.{{year}}.",
  "clo.cash.openPosting": "Opprett fri postering",
  "clo.cash.postingTitle": "Korriger kontantbeholdning",
  "clo.cash.postingDescription": "Korreksjon etter kontantopptelling {{year}}",
  "clo.cash.postingLoadError": "Kunne ikke laste fri postering.",
  "clo.cash.postingSaved": "Posteringen er bokført. Kontroller differansen på nytt."
});
